import { useQuery } from '@tanstack/react-query';
import { api, GameStateResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseAdminGameStateReturn {
  gameState: GameStateResponse | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useAdminGameState(username: string, keyword: string): UseAdminGameStateReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.gameState.adminDetail(`${username}:${keyword}`),
    queryFn: () => api.adminGetGameState(username, keyword),
    enabled: !!username && !!keyword,
  });

  return {
    gameState: data?.gameState ?? null,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load game state' : null,
    refresh: () => {
      refetch();
    },
  };
}
